import { cn } from "@becon-team/becon-fe-lib/my-tailwind-css";
import { ReactNode } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

import type { PropsWithClassName } from "@becon-team/becon-fe-lib/my-types";

export interface GroupBtnFormInputProps {
  labelClass?: string;
  options:
    | (string | number)[]
    | {
        display: ReactNode;
        value: string | number;
      }[];
  formatOption?: (option: string | number) => ReactNode;
  registerProps?: UseFormRegisterReturn;
  disabled?: boolean;
}

export const GroupBtnFormInput = ({
  className,
  labelClass,
  options,
  formatOption = (option) => option,
  registerProps,
  disabled = false,
}: PropsWithClassName<GroupBtnFormInputProps>) => {
  return (
    <div className={cn("grid grid-cols-1 gap-sp-6", className)}>
      {options.map((option, idx) => {
        const value = typeof option === "string" || typeof option === "number" ? option : option.value;
        const display =
          typeof option === "string" || typeof option === "number" ? formatOption(option) : option.display;

        return (
          <label key={idx} className={cn("min-h-btn-md", labelClass)}>
            <input {...registerProps} value={value} className="my-peer-check-input peer" disabled={disabled} />
            <div
              className={cn(
                "my-peer-check-label peer-checked:my-peer-check-label-checked peer-disabled:my-peer-check-label-disabled h-full",
                labelClass,
              )}
            >
              {display}
            </div>
          </label>
        );
      })}
    </div>
  );
};
